'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _timeStringBigger = require('./timeStringBigger');

var _timeStringBigger2 = _interopRequireDefault(_timeStringBigger);

var _timeStringSmaller = require('./timeStringSmaller');

var _timeStringSmaller2 = _interopRequireDefault(_timeStringSmaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (start, end, target) {
    if ((0, _timeStringBigger2.default)(end, start)) {
        return (0, _timeStringBigger2.default)(target, start) && (0, _timeStringSmaller2.default)(target, end);
    }
    /**
     * if open time is bigger than close time
     * target should not between close and open time
     * eg. '09:00:00' is not between '23:00:00' (start) and '08:00:00'(close)
     * because it is between '08:00:00' to '23:00:00'
     * */

    return !((0, _timeStringBigger2.default)(target, end) && (0, _timeStringSmaller2.default)(target, start));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/date/timeStringIsBetween.js
// module id = 350
// module chunks = 0